import { Attributes, Model, ModelBase, NeoModel, Rules, Validation } from "@singularsystems/neo-core";
import { LookupFields } from "../IssuerInvestment";
import IssuerLookup from "../../Issuers/Lookups/IssuerLookup";

@NeoModel
export default class NewIssuerInvestmentCommand extends ModelBase {

    @Rules.Required()
    public entityId: number | null = null;

    @Rules.Required()
    public issuerId: number | null = null;

    @Attributes.Nullable()
    public investorInvestmentId: number | null = null;

    public lookup = new LookupFields();

    // Client only properties / methods

    public setIssuer(issuer: Model.PlainObject<IssuerLookup> | undefined) {
        this.issuerId = issuer?.issuerId ?? null;
        this.lookup.issuerName = issuer?.issuerName ?? null;
        this.isIssuerRestricted = issuer?.isRestricted ?? false;
    }

    @Attributes.NoTracking()
    public isIssuerRestricted = false;

    protected addBusinessRules(context: Validation.Rules<NewIssuerInvestmentCommand>) {

        context.failWhen(c => c.isIssuerRestricted, "Issuer is restricted from trading.").onProperties(c => c.issuerId);
    }
}